import { render, staticRenderFns } from "./AlertBig.vue?vue&type=template&id=b9deeb58&"
import script from "./AlertBig.vue?vue&type=script&lang=js&"
export * from "./AlertBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports